import { render, staticRenderFns } from "./GreenFitOutFolders.vue?vue&type=template&id=39e39d8e&scoped=true&"
import script from "./GreenFitOutFolders.vue?vue&type=script&lang=js&"
export * from "./GreenFitOutFolders.vue?vue&type=script&lang=js&"
import style0 from "./GreenFitOutFolders.vue?vue&type=style&index=0&id=39e39d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e39d8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39e39d8e')) {
      api.createRecord('39e39d8e', component.options)
    } else {
      api.reload('39e39d8e', component.options)
    }
    module.hot.accept("./GreenFitOutFolders.vue?vue&type=template&id=39e39d8e&scoped=true&", function () {
      api.rerender('39e39d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/greenFitOut/GreenFitOutFolders.vue"
export default component.exports